/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Button, Layout, Popover, Space, theme } from 'antd';
import { useAppDispatch, useAuthState } from '@core/.';
import { logout } from '@core/features/auth/thunks';
import { LoadingOutlined, LogoutOutlined, MenuOutlined } from '@ant-design/icons';
import { AuthUser } from '@core/models';
import { GLOBAL_THEME_COLOR } from '@constants/theme';
import { useBreakpoint } from '@core/hooks/useBreakpoint';
import { BRAND_LOGO_CONSTRAST, BRAND_NAME } from '@constants/brand';
import { MIDDLE_STYLE } from '@constants/responsive';
import { openDrawer } from '@core/features';
import { SelectBusinessButton } from '..';

type Props = {};

const BookingAppBar = (props: Props) => {
  const { isTablet } = useBreakpoint();
  const { user } = useAuthState();
  const dispatch = useAppDispatch();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleLogout = () => {
    dispatch(logout());
  };

  const hoverContent = (user: AuthUser) => (
    <div>
      <h3>{`${user.given_name} ${user.family_name}`}</h3>
      <p>{`${user.email}`}</p>
      <Space direction="vertical" style={{ marginTop: 20 }}>
        <Button style={{ width: '100%', color: 'red' }} onClick={handleLogout}>
          <LogoutOutlined />
          Logout
        </Button>
      </Space>
    </div>
  );

  return (
    <Layout.Header
      style={{
        padding: '0px 40px',
        background: colorBgContainer,
        display: 'flex',
        height: 80,
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${GLOBAL_THEME_COLOR.$border_color}`,
      }}>
      <div style={{ ...MIDDLE_STYLE }}>
        {!isTablet ? (
          <div style={{ ...MIDDLE_STYLE }}>
            <img src={BRAND_LOGO_CONSTRAST} alt={BRAND_NAME} style={{ width: 40 }} />{' '}
            {!isTablet && (
              <span
                style={{
                  color: GLOBAL_THEME_COLOR.$text_color,
                  fontWeight: 'bold',
                  fontSize: 16,
                  marginLeft: 10,
                }}>
                {BRAND_NAME.toUpperCase()}
              </span>
            )}
          </div>
        ) : (
          <img src={BRAND_LOGO_CONSTRAST} alt={BRAND_NAME} style={{ width: 40 }} />
        )}
      </div>
      <div style={{ ...MIDDLE_STYLE }}>
        <div style={{ marginRight: 50 }}>
          <SelectBusinessButton redirect="booking" />
        </div>
        {user ? (
          <React.Fragment>
            <div></div>
            <Popover content={hoverContent(user)}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}>
                <img
                  referrerPolicy="no-referrer"
                  style={{ width: 35, borderRadius: 50 }}
                  src={user.picture}
                  alt={user.picture}
                />
                {!isTablet && (
                  <div style={{ marginLeft: 10 }}>
                    <h4>{`${user.given_name} ${user.family_name}`}</h4>
                  </div>
                )}
              </div>
            </Popover>
          </React.Fragment>
        ) : (
          <LoadingOutlined />
        )}
        {isTablet && (
          <MenuOutlined
            style={{ cursor: 'pointer', margin: '0px 0px 0px 20px' }}
            onClick={() =>
              dispatch(
                openDrawer({
                  drawerName: 'navigationDrawer',
                })
              )
            }
          />
        )}
      </div>
    </Layout.Header>
  );
};

export default BookingAppBar;
